import { request } from './request';

/**
 * 栏目文章项
 */
export interface ColumnArticle {
  id: number;
  categoryId: number;
  title: string;
  subtitle: string;
  summary: string;
  content: string;
  contentText: string;
  coverImage: string;
  author: string;
  publishTime: string;
  attachment: string;
}

/**
 * 栏目分页参数
 */
export interface ColumnPageParams {
  categoryId: number;
  pageNum: number;
  pageSize: number;
}

/**
 * 栏目分页响应
 */
export interface ColumnPageResponse {
  code: number;
  data: ColumnArticle[];
  msg: string;
  total: number;
}

/**
 * 获取党群园地栏目分页数据
 * @param params - 分页参数
 * categoryId: 48-党群动态 49-规章制度 50-通知公告 51-创新文化
 */
export function getColumnPage(params: ColumnPageParams) {
  return request.get('/party_home/columnPage', params);
}

/**
 * 文章列表项
 */
export interface ArticleItem {
  id: string;
  title: string;
  slug: string;
  publishTime: string;
  summary?: string;
  coverImage?: string;
}

/**
 * 新闻分类项
 */
export interface NewsCategory {
  id: number;
  name: string;
  slug: string;
  type: string;
  sortOrder: number;
  articlesList: ArticleItem[];
}

/**
 * 首页新闻响应
 */
export interface PartyHomeNewsResponse {
  code: number;
  data: NewsCategory[];
  msg: string;
  total: number;
}

/**
 * 获取首页新闻等资讯
 */
export function getPartyHomeNews() {
  return request.get('/party_home/news');
}

/**
 * 新闻详情
 */
export interface NewsDetail {
  id: number;
  categoryId: number;
  title: string;
  subtitle: string;
  summary: string;
  content: string;
  contentText: string;
  coverImage: string;
  author: string;
  publishTime: string;
  attachment: string;
}

/**
 * 新闻详情响应
 */
export interface NewsDetailResponse {
  code: number;
  data: NewsDetail;
  msg: string;
  total: number;
}

/**
 * 根据id获取新闻详情
 * @param id - 新闻id
 */
export function getPartyNewsDetail(id: string | number) {
  return request.get(`/party_home/news/${id}`);
}
